import { NgModule } from '@angular/core';
import { ModelerComponent } from './modeler.component/modeler.component';
import { BpmnModelerService } from '@ispm-client/modules/bpmn-modeler/service/bpmn-modeler.service';
import { NodeCreatorComponent } from '@ispm-client/modules/bpmn-modeler/node-creator.component/node-creator.component';
import { LayoutModule } from '@ispm/layout/layout.module';
import { ModelerPanelService } from '@ispm-client/modules/bpmn-modeler/service/modeler-panel.service';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { TreatmentPlanSelectorComponent } from '@ispm-client/modules/bpmn-modeler/treatment-plan-selector.component/treatment-plan-selector.component';
import { SharedModule } from '@ispm/shared/shared.module';
import { CheckboxModule } from 'primeng/checkbox';
import { CheckBoxModule as DLSCheckboxModule } from '@wuitk/angular/components/checkbox';
import { PanelModule } from 'primeng/panel';
import { DynamicFormModule } from '@ispm/dynamic-form/dynamic-form.module';
import { EffectsModule } from '@ngrx/effects';
import { SaveBpmnEffect } from '@ispm-client/modules/bpmn-modeler/store/effects';
import { BpmnDeploymentService } from '@ispm-client/modules/bpmn-modeler/service/bpmn-deployment.service';
import { QueryBuilderModule } from '@ispm-client/modules/query-builder';
import { BpmnXmlService } from '@ispm/shared/bpmn/services/bpmn-xml.service';
import { CitationsInformationComponent } from '@ispm-client/modules/bpmn-modeler/citations-information/citations-information.component';
import { NotesModule } from '../../app/notes/notes.module';
import { ModelApprovalComponent } from '@ispm-client/modules/bpmn-modeler/model-approval.component/model-approval.component';
import { ModelApprovalPanelService } from '@ispm-client/modules/bpmn-modeler/service/model-approval-panel.service';
import { NavigateNodeEffect } from '@ispm-client/modules/bpmn-modeler/store/effects/navigate-node.effect';
import { bpmnModelerMetaReducerA, metaReducers } from '@ispm-client/modules/bpmn-modeler/store/reducer/reducers';
import { CoreModule } from '@ispm/core/core.module';
import { ClinicalTrialSelectorComponent } from './clinical-trial-selector.component/clinical-trial-selector.component';
import { NodePanelConfigurationService } from '@ispm-client/modules/bpmn-modeler/service/node-panel-configuration.service';
import { SelectorUrlBuilderService } from '@ispm-client/modules/bpmn-modeler/service/selector-url-builder.service';
import { DlsSharedModule } from "../../app/dls-shared.module";
import {
  TrialPlacementNodesComponent
} from "@ispm-client/modules/bpmn-modeler/trial-placement-node/trial-placement-node.component";
import { TreeViewPanelService } from '@ispm-client/modules/bpmn-modeler/service/tree-view-panel.service';
import { CurationPathwayTreeViewerComponent } from "./curation-pathway-tree-viewer/curation-pathway-tree-viewer.component";
import { NavigateNodeWithDataEffect } from '@ispm-client/modules/bpmn-modeler/store/effects/navigate-node-with-data.effect';
import {SelectionNodeEffect} from "@ispm-client/modules/bpmn-modeler/store/effects/selection-node.effect";
import {UpdateTreatmentNodesPropertiesEffect} from "@ispm-client/modules/bpmn-modeler/store/effects/update-treatment-nodes-properties.effect";

@NgModule({
  imports: [
    CoreModule,
    ButtonModule,
    FormsModule,
    QueryBuilderModule,
    LayoutModule.forRoot(),
    StoreModule.forFeature('BpmnModeler', bpmnModelerMetaReducerA, { metaReducers}),
    EffectsModule.forFeature([SaveBpmnEffect, NavigateNodeEffect, NavigateNodeWithDataEffect, SelectionNodeEffect, UpdateTreatmentNodesPropertiesEffect]),
    SharedModule,
    PanelModule,
    DynamicFormModule,
    CheckboxModule,
    NotesModule,
    DLSCheckboxModule,
    DlsSharedModule
  ],
  declarations: [
    ModelerComponent,
    NodeCreatorComponent,
    TreatmentPlanSelectorComponent,
    CitationsInformationComponent,
    ModelApprovalComponent,
    ClinicalTrialSelectorComponent,
    TrialPlacementNodesComponent,
    CurationPathwayTreeViewerComponent
  ],
  exports: [ModelerComponent],
  providers: [
    BpmnModelerService,
    BpmnXmlService,
    ModelerPanelService,
    BpmnDeploymentService,
    NavigateNodeEffect,
    SaveBpmnEffect,
    ModelApprovalPanelService,
    NodePanelConfigurationService,
    SelectorUrlBuilderService,
    TreeViewPanelService,
    NavigateNodeWithDataEffect,
    SelectionNodeEffect,
    UpdateTreatmentNodesPropertiesEffect
  ]
})
export class BpmnModelerModule {
}
